<template>
    <section class="section">
        <div>
            <b-row>
                <b-col>
                    <b-card title="Fattori CO₂">
                        <b-row class="mt-5">
                            <b-col class="d-flex"> 
                                <div class="mr-3">
                                    <label>Filtra per vettore</label>
                                    <b-form-select class="filter form-control" v-model="type" :options="vectors"></b-form-select>
                                </div>
                                <div>
                                    <label>Filtra per fornitore </label>
                                    <b-form-select class="filter form-control" v-model="name" :options="suppliers"></b-form-select>
                                </div>
                                <div class="d-flex justify-content-end flex-grow-1">
                                    <b-btn variant="btn btn-success" v-b-modal.modalSupplier @click="showNewModal()">Nuovo</b-btn>    
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="mt-4">
                            <b-col>
                                <vue-good-table
                                :columns="columns"
                                :rows="rows"
                                :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    perPage: 50,
                                    position: 'bottom',
                                    perPageDropdown: [50, 100, 200, 500],
                                    dropdownAllowAll: true,
                                    setCurrentPage: 1,
                                    jumpFirstOrLast : true,
                                    firstLabel : 'First Page',
                                    lastLabel : 'Last Page',
                                    nextLabel: 'next',
                                    prevLabel: 'prev',
                                    rowsPerPageLabel: 'Rows per page',
                                    ofLabel: 'of',
                                    pageLabel: 'page',
                                    allLabel: 'All',
                                }">
                                    <template #table-row="props">
                                        <span v-if="props.column.field == 'actions'">
                                            <div class="d-flex">
                                                <b-btn variant="btn btn-warning" v-b-modal.modalSupplier @click="showEditForm(props.row)">Modifica</b-btn> 
                                                <b-btn variant="btn btn-danger" @click="remove(props.row)">Elimina</b-btn> 
                                            </div>
                                        </span>
                                        <span v-else>
                                            {{ props.formattedRow[props.column.field] }}
                                        </span>
                                    </template>
                                </vue-good-table>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <b-modal id="modalSupplier" @ok="submit()" ok-title="Salva" centered :title="currentSupplier.id ? 'Modifica Fornitore' : 'Nuovo Fornitore'">
            <form role="form">
                <b-row class="mb-4">
                    <b-col class="col-4">
                        <label class="form-label align-self-center mr-3">Fornitore</label>
                    </b-col>
                    <b-col class="col-8">
                        <input class="form-control" type="text" v-model="currentSupplier.supplier" required />
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col class="col-4">
                        <label class="form-label align-self-center mr-3">Vettore</label>
                    </b-col>
                    <b-col class="col-8">
                        <b-form-select class="form-control" :options="vectors" v-model="currentSupplier.vector" required></b-form-select>
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col class="col-4">
                        <label class="form-label align-self-center mr-3">Anno</label>
                    </b-col>
                    <b-col class="col-8">
                        <input class="form-control" type="number" v-model="currentSupplier.year" required />
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col class="col-4">
                        <label class="form-label align-self-center mr-2">gCO₂/kWh</label>
                    </b-col>
                    <b-col class="col-8">
                        <input class="form-control" type="number" v-model="currentSupplier.factor" required />
                    </b-col>
                </b-row>
            </form>
        </b-modal>
    </section>
</template>
<script>

import api from '@/services/api';
import Table from '../Charts/Table.vue';
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';

export default {
  components: { Table, VueGoodTable },
    name: "COSuppliers",
    data() {
        return {
            coSuppliers: [],
            copyCoSuppliers: [],
            type: null,
            name: null,
            vectors: [
                { value: "EE", text: "EE" },
                { value: "gas", text: "gas" },
                { value: "olioc", text: "olioc" },
                { value: "GPL", text: "GPL" },
                { value: "Diesel", text: "Diesel" },
                { value: "CDR", text: "CDR" },
                { value: "spll", text: "spll" },
                { value: "benz", text: "benz" },
                { value: "t", text: "t" },
                { value: "fluidth", text: "fluidth" },
                { value: "water", text: "water" },
                { value: "KJF", text: "KJF" },
            ],  
            rows: null, 
            columns: [
                {
                    label: 'Fornitore',
                    field: 'supplier',
                    sortable: false,
                },
                {
                    label: 'Vettore',
                    field: 'vector',
                    sortable: false,
                },
                {
                    label: 'Anno',
                    field: 'year',
                    sortable: false,
                },
                {
                    label: 'gCO₂/kWh',
                    field: 'factor',
                    sortable: false,
                },
                {
                    label: '',
                    field: 'actions',
                    type: 'button',
                    width: '200px   ',
                    sortable: false,
                }
            ],  
            suppliers: [],
            currentSupplier: {},
        }
    },
    created() {
        this.load();
    },
    watch: {
        type() {
            this.filters();
        },
        name() {
            this.filters();
        }
    },

    methods: {
        load() {
            this.$store.commit("loading");
            api().get('/co2').then( data => {
                this.coSuppliers = data.data.data;
                this.rows = this.coSuppliers;
                this.copyCoSuppliers = this.coSuppliers;
                this.vectors = ["", ...this.vectors];
                this.suppliers = ["", ...this.coSuppliers.map(item => item = item.supplier)];
                this.$store.commit("stopLoading");
            });
        },
        filters() {
            this.rows = this.coSuppliers.filter( item => {
                if(this.type && item.vector != this.type) {
                    return false;
                }
                if(this.name && item.supplier != this.name) {
                    return false;
                }
                return true;
            });
        },
        async submit() {
            try {
                this.$store.commit("loading");
                if(this.currentSupplier.id) {
                    await api().patch(`/co2`, this.currentSupplier);
                } else {
                    await api().post('/co2', this.currentSupplier);
                }
                this.$store.commit("stopLoading");  
                if(this.currentSupplier.id) {
                    this.$notify({
                        type: "success",
                        title: 'Successo',
                        text: "Fornitore modificato con successo"
                    });    
                } else {
                    this.$notify({
                        type: "success",
                        title: 'Successo',
                        text: "Fornitore creato con successo"
                    });
                }
                this.resetFilters();
            } catch(e) {
                this.$notify({
                    type: "error",
                    text: e.message,
                    title: 'Errore',
                });
            }
            this.load();
        },
        async remove(supplier) {
            this.$swal({
                title: `Sei sicuro di voler rimuovere ${supplier.supplier} ?`,
                showDenyButton: true,
                showCancelButton: true,
                showConfirmButton: false,
                denyButtonText: "Conferma",
                cancelButtonText: "Annulla",
            }).then(async (result) => {
                if(result.isDenied) {
                    try {
                        this.$store.commit("loading");
                        await api().delete(`/co2/${supplier.id}`);
                        this.$store.commit("stopLoading");
                        this.$notify({
                            type: "success",
                            title: 'Successo',
                            text: "Fornitore eliminato con successo"
                        });
                    } catch(e) {
                        this.$notify({
                            type: "error",
                            text: e.message,
                            title: 'Errore',
                        });
                    }
                }
                this.load();
            })
        },
        showNewModal() {
            this.currentSupplier = {};
        },
        showEditForm(supplier) {
            this.currentSupplier = supplier;
        },
        resetFilters() {
            this.type = null;
            this.name = null;
        }
    }
}
</script>

<style>
    .filter {
        width: 200px;
        display: inline-block;
    }
    .item {
        background-color: #f2f2f2;
    }
    .item2 {
        background-color: white;
    }
    .modal.show {
        display: block;
    }
    .btn-default {
        background: #999999;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/COSuppliers.vue